import { CatalogMode, getWithAuthn } from "../../RequestHelpers";
export var deserializeUserCatalog = function (jsonCatalog) {
    var probeSet = deserializeProbeSetCatalog(jsonCatalog.probeSet);
    var cishAmplifier = deserializeCishUserAmplifierCatalog(jsonCatalog.cishAmplifier);
    var legacyFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.legacyFishAmplifier);
    var goldFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.goldFishAmplifier);
    var cishBuffer = deserializeCishBufferCatalog(jsonCatalog.cishBuffer);
    var manualProAmpCatalog = deserializeCishUserAmplifierCatalog(jsonCatalog.manualProAmpCatalog);
    var legacyFishBuffer = deserializeFishBufferCatalog(jsonCatalog.legacyFishBuffer);
    var goldFishBuffer = deserializeFishBufferCatalog(jsonCatalog.goldFishBuffer);
    var cishProtocols = jsonCatalog.cishProtocols;
    var cishChromogens = deserializeCishChromogenCatalog(jsonCatalog.cishChromogens);
    return {
        cishProtocols: cishProtocols,
        cishChromogens: cishChromogens,
        probeSet: probeSet,
        cishAmplifier: cishAmplifier,
        legacyFishAmplifier: legacyFishAmplifier,
        goldFishAmplifier: goldFishAmplifier,
        manualProAmpCatalog: manualProAmpCatalog,
        cishBuffer: cishBuffer,
        goldFishBuffer: goldFishBuffer,
        legacyFishBuffer: legacyFishBuffer
    };
};
export var deserializeAdminCatalog = function (jsonCatalog) {
    var probeSet = deserializeProbeSetCatalog(jsonCatalog.probeSet);
    var cishAmplifier = deserializeAdminAmplifierCatalog(jsonCatalog.cishAmplifier);
    var legacyFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.legacyFishAmplifier);
    var goldFishAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.goldFishAmplifier);
    var cishBuffer = deserializeCishBufferCatalog(jsonCatalog.cishBuffer);
    var manualProAmpCatalog = deserializeCishUserAmplifierCatalog(jsonCatalog.manualProAmpCatalog);
    var legacyFishBuffer = deserializeFishBufferCatalog(jsonCatalog.legacyFishBuffer);
    var goldFishBuffer = deserializeFishBufferCatalog(jsonCatalog.goldFishBuffer);
    var cishProtocols = jsonCatalog.cishProtocols;
    var cishChromogens = deserializeCishChromogenCatalog(jsonCatalog.cishChromogens);
    return {
        cishProtocols: cishProtocols,
        cishChromogens: cishChromogens,
        probeSet: probeSet,
        cishAmplifier: cishAmplifier,
        legacyFishAmplifier: legacyFishAmplifier,
        goldFishAmplifier: goldFishAmplifier,
        manualProAmpCatalog: manualProAmpCatalog,
        cishBuffer: cishBuffer,
        goldFishBuffer: goldFishBuffer,
        legacyFishBuffer: legacyFishBuffer
    };
};
export var deserializeProbeSetCatalog = function (jsonProbeSetCatalog) {
    var probeSet = {
        catalog: {
            organisms: jsonProbeSetCatalog.catalog.organisms.map(function (o) { return new LibraryOrganism(o.id, o.name, o.scientificName, function (libOrg) {
                return o.probeSetFamilies.map(function (jsonFamily) {
                    return new ProbeSetFamily(jsonFamily.id, jsonFamily.geneSymbol, jsonFamily.description, jsonFamily.geneType, jsonFamily.accessions, jsonFamily.synonyms, function (psf) {
                        return jsonFamily.variants.map(function (v) {
                            return {
                                id: v.id,
                                organism: libOrg,
                                probeSetFamily: psf,
                                name: v.name,
                                designNumber: v.designNumber,
                                targetMrnaSeq: v.targetMrnaSeq,
                                accession: v.accession ? new Accession(v.accession.id, v.accession.transcriptAccession, v.accession.accessionType, v.accession.transcriptLength, v.accession.transcriptName) : undefined,
                                probeSetSize: v.probeSetSize,
                                validated: v.validated,
                                dcvScore: v.dcvScore
                            };
                        });
                    }, function (psf) {
                        return {
                            id: jsonFamily.defaultVariant.id,
                            organism: libOrg,
                            probeSetFamily: psf,
                            name: jsonFamily.defaultVariant.name,
                            designNumber: jsonFamily.defaultVariant.designNumber,
                            targetMrnaSeq: jsonFamily.defaultVariant.targetMrnaSeq,
                            accession: jsonFamily.defaultVariant.accession ? new Accession(jsonFamily.defaultVariant.accession.id, jsonFamily.defaultVariant.accession.transcriptAccession, jsonFamily.defaultVariant.accession.accessionType, jsonFamily.defaultVariant.accession.transcriptLength, jsonFamily.defaultVariant.accession.transcriptName) : undefined,
                            probeSetSize: jsonFamily.defaultVariant.probeSetSize,
                            validated: jsonFamily.defaultVariant.validated,
                            dcvScore: jsonFamily.defaultVariant.dcvScore
                        };
                    });
                });
            }); }),
            fishScalePmols: jsonProbeSetCatalog.catalog.fishScalePmols.map(function (s) { return new Pmol(s); }),
            fishDefaultScale: new Pmol(jsonProbeSetCatalog.catalog.fishDefaultScalePmol),
            cishScale: jsonProbeSetCatalog.catalog.cishScale,
            cishDefaultScale: jsonProbeSetCatalog.catalog.cishDefaultScale
        },
        custom: {
            probeSetSizes: jsonProbeSetCatalog.custom.probeSetSizes,
            fishScalePmols: jsonProbeSetCatalog.custom.fishScalePmols.map(function (s) { return new Pmol(s); }),
            fishDefaultScale: new Pmol(jsonProbeSetCatalog.custom.fishDefaultScalePmol),
            cishScale: jsonProbeSetCatalog.custom.cishScale,
            cishDefaultScale: jsonProbeSetCatalog.custom.cishDefaultScale
        }
    };
    return probeSet;
};
export var deserializeAdminAmplifierCatalog = function (jsonAmpCatalog) {
    var amplifier = {
        enzymes: jsonAmpCatalog.enzymes.map(function (e) {
            return new CishUserAmplifierConfig(e.id, e.displayName, e.protocolType, new HcrAmplifier(e.amplifier.id), new Hapten(e.hapten), e.antiHapten1, e.tyramideHapten, e.visible, e.antiHapten2Ap, e.antiHapten2Hrp);
        }),
        hcrAmplifiers: jsonAmpCatalog.hcrAmplifiers.map(function (h) { return new HcrAmplifier(h.id); }),
        defaultHcrAmplifier: new HcrAmplifier(jsonAmpCatalog.defaultHcrAmplifier.id),
        hapten: jsonAmpCatalog.hapten.map(function (h) { return new Hapten(h); }),
        defaultHapten: new Hapten(jsonAmpCatalog.defaultHapten),
        antiHapten1: jsonAmpCatalog.antiHapten1,
        defaultAntiHapten1: jsonAmpCatalog.defaultAntiHapten1,
        tyramideHapten: jsonAmpCatalog.tyramideHapten,
        defaultTyramideHapten: jsonAmpCatalog.defaultTyramideHapten,
        antiHapten2Ap: jsonAmpCatalog.antiHapten2Ap,
        antiHapten2Hrp: jsonAmpCatalog.antiHapten2Hrp,
        defaultAntiHapten2Ap: jsonAmpCatalog.defaultAntiHapten2Ap,
        defaultAntiHapten2Hrp: jsonAmpCatalog.defaultAntiHapten2Hrp,
        proAmplifierScales: jsonAmpCatalog.proAmplifierScales,
        proDefaultAmplifierScale: jsonAmpCatalog.proDefaultAmplifierScale,
        manualProAmplifierScales: jsonAmpCatalog.manualProAmplifierScales,
        manualProDefaultAmplifierScale: jsonAmpCatalog.manualProDefaultAmplifierScale
    };
    return amplifier;
};
export var deserializeCishUserAmplifierCatalog = function (jsonAmpCatalog) {
    var amplifier = {
        amplifierConfig: jsonAmpCatalog.amplifierConfig.map(function (j) {
            return new CishUserAmplifierConfig(j.id, j.displayName, j.protocolType, new HcrAmplifier(j.amplifier.id), new Hapten(j.hapten), j.antiHapten1, j.tyramideHapten, j.visible, j.antiHapten2Ap, j.antiHapten2Hrp);
        }),
        amplifierScales: jsonAmpCatalog.amplifierScales.map(function (a) { return a; }),
        defaultAmplifierScale: jsonAmpCatalog.defaultAmplifierScale
    };
    return amplifier;
};
export var deserializeFishAmplifierCatalog = function (jsonAmpCatalog) {
    var amplifier = {
        channels: jsonAmpCatalog.channels.map(function (c) {
            return {
                hcrAmplifier: new HcrAmplifier(c.hcrAmplifier.id),
                labels: new PredefinedLabels(c.labels.standard.map(function (s) {
                    return {
                        label: new PredefinedLabel(s.label.id, s.label.name, s.label.isStandard),
                        scales: s.scalePmols.map(function (scale) {
                            return new Pmol(scale);
                        }),
                        defaultScale: new Pmol(s.defaultScalePmol)
                    };
                }), c.labels.extended.map(function (e) {
                    return {
                        label: new PredefinedLabel(e.label.id, e.label.name, e.label.isStandard),
                        scales: e.scalePmols.map(function (scale) {
                            return new Pmol(scale);
                        }),
                        defaultScale: new Pmol(e.defaultScalePmol)
                    };
                })),
                defaultLabel: {
                    label: new PredefinedLabel(c.defaultLabel.label.id, c.defaultLabel.label.name, c.defaultLabel.label.isStandard),
                    scales: c.defaultLabel.scalePmols.map(function (s) {
                        return new Pmol(s);
                    }),
                    defaultScale: new Pmol(c.defaultLabel.defaultScalePmol)
                },
                forwardCompatibility: c.forwardCompatibility.map(function (fc) {
                    return new PredefinedLabel(fc.id, fc.name, fc.isStandard);
                })
            };
        }),
        defaultChannel: {
            hcrAmplifier: new HcrAmplifier(jsonAmpCatalog.defaultChannel.hcrAmplifier.id),
            labels: new PredefinedLabels(jsonAmpCatalog.defaultChannel.labels.standard.map(function (s) {
                return {
                    label: new PredefinedLabel(s.label.id, s.label.name, s.label.isStandard),
                    scales: s.scalePmols.map(function (scale) {
                        return new Pmol(scale);
                    }),
                    defaultScale: new Pmol(s.defaultScalePmol)
                };
            }), jsonAmpCatalog.defaultChannel.labels.extended.map(function (e) {
                return {
                    label: new PredefinedLabel(e.label.id, e.label.name, e.label.isStandard),
                    scales: e.scalePmols.map(function (scale) {
                        return new Pmol(scale);
                    }),
                    defaultScale: new Pmol(e.defaultScalePmol)
                };
            })),
            defaultLabel: {
                label: new PredefinedLabel(jsonAmpCatalog.defaultChannel.defaultLabel.label.id, jsonAmpCatalog.defaultChannel.defaultLabel.label.name, jsonAmpCatalog.defaultChannel.defaultLabel.label.isStandard),
                scales: jsonAmpCatalog.defaultChannel.defaultLabel.scalePmols.map(function (s) {
                    return new Pmol(s);
                }),
                defaultScale: new Pmol(jsonAmpCatalog.defaultChannel.defaultLabel.defaultScalePmol)
            },
            forwardCompatibility: jsonAmpCatalog.defaultChannel.forwardCompatibility.map(function (fc) {
                return new PredefinedLabel(fc.id, fc.name, fc.isStandard);
            })
        },
        freeTextLabelScales: jsonAmpCatalog.freeTextLabelScalePmols.map(function (p) { return new Pmol(p); })
    };
    return amplifier;
};
export var deserializeCishBufferCatalog = function (jsonBuffCatalog) {
    var buffer = {
        sampleTypes: jsonBuffCatalog.sampleTypes,
        defaultSampleType: jsonBuffCatalog.defaultSampleType,
        proBufferScales: jsonBuffCatalog.proBufferScales,
        proDefaultBufferScale: jsonBuffCatalog.proDefaultBufferScale,
        manualProBufferScales: jsonBuffCatalog.manualProBufferScales,
        manualProDefaultBufferScale: jsonBuffCatalog.manualProDefaultBufferScale
    };
    return buffer;
};
export var deserializeFishBufferCatalog = function (jsonBuffCatalog) {
    if (isLegacyBufferCatalog(jsonBuffCatalog)) {
        return new LegacyFishBufferCatalog(jsonBuffCatalog.sampleTypes, jsonBuffCatalog.defaultSampleType, extractBufferMetadata(jsonBuffCatalog.wash), extractBufferMetadata(jsonBuffCatalog.amplifier), extractBufferMetadata(jsonBuffCatalog.hybridization));
    }
    else {
        return new GoldFishBufferCatalog(jsonBuffCatalog.sampleTypes, jsonBuffCatalog.defaultSampleType, extractBufferMetadata(jsonBuffCatalog.goldWash), extractBufferMetadata(jsonBuffCatalog.amplifier), extractBufferMetadata(jsonBuffCatalog.hybridization), extractBufferMetadata(jsonBuffCatalog.goldAmpWash), extractBufferMetadata(jsonBuffCatalog.proAmpWash));
    }
};
export var deserializeCishChromogenCatalog = function (jsonChromogenCatalog) {
    var chromogen = {
        chromogens: jsonChromogenCatalog.chromogens,
        chromogenBuffers: jsonChromogenCatalog.chromogenBuffers,
        proChromogenScales: jsonChromogenCatalog.proChromogenScales,
        proDefaultChromogenScale: jsonChromogenCatalog.proDefaultChromogenScale,
        manualProChromogenScales: jsonChromogenCatalog.manualProChromogenScales,
        manualProDefaultChromogenScale: jsonChromogenCatalog.manualProDefaultChromogenScale
    };
    return chromogen;
};
export var extractBufferMetadata = function (jbm) {
    return {
        volumeMls: jbm.volumeMls.map(function (v) { return new LiquidVolume(v); }),
        defaultVolumeMl: new LiquidVolume(jbm.defaultVolumeMl)
    };
};
export var getFishAmplifierCatalog = function (legacy, catalog) {
    return legacy ? catalog.legacyFishAmplifier : catalog.goldFishAmplifier;
};
// tslint:disable-next-line:max-classes-per-file
var RnaCishProbeSetScale = /** @class */ (function () {
    function RnaCishProbeSetScale(slides, pmolScale, labelA, labelB, detailA, detailB) {
        this.slides = slides;
        this.pmolScale = pmolScale;
        this.slidesWithUnit = slides + " slides";
        this.labelA = labelA;
        this.labelB = labelB;
        this.detailA = detailA;
        this.detailB = detailB;
    }
    return RnaCishProbeSetScale;
}());
export { RnaCishProbeSetScale };
// tslint:disable-next-line:max-classes-per-file
var LibraryOrganism = /** @class */ (function () {
    function LibraryOrganism(id, name, scientificName, probeSetFamiliesCreator) {
        this.id = id;
        this.name = name;
        this.scientificName = scientificName;
        this.probeSetFamilies = probeSetFamiliesCreator(this);
    }
    return LibraryOrganism;
}());
export { LibraryOrganism };
// tslint:disable-next-line:max-classes-per-file
var ProbeSetFamily = /** @class */ (function () {
    function ProbeSetFamily(id, geneSymbol, description, geneType, accessions, synonyms, variantsCreator, defaultVariantCreator) {
        this.id = id;
        this.geneSymbol = geneSymbol;
        this.description = description;
        this.geneType = geneType;
        this.variants = variantsCreator(this);
        this.defaultVariant = defaultVariantCreator(this);
        this.accessions = accessions;
        this.synonyms = synonyms;
    }
    return ProbeSetFamily;
}());
export { ProbeSetFamily };
// tslint:disable-next-line:max-classes-per-file
var Variant = /** @class */ (function () {
    function Variant(id, organism, probeSetFamily, name, designNumber, targetMrnaSeq, probeSetSize, validated, accession, dcvScore) {
        this.id = id;
        this.organism = organism;
        this.probeSetFamily = probeSetFamily;
        this.name = name;
        this.designNumber = designNumber;
        this.targetMrnaSeq = targetMrnaSeq;
        this.accession = accession;
        this.probeSetSize = probeSetSize;
        this.validated = validated;
        this.dcvScore = dcvScore;
    }
    return Variant;
}());
export { Variant };
var Accession = /** @class */ (function () {
    function Accession(id, transcriptAccession, accessionType, transcriptLength, transcriptName) {
        this.id = id;
        this.transcriptAccession = transcriptAccession;
        this.transcriptName = transcriptName;
        this.transcriptLength = transcriptLength;
        this.accessionType = accessionType;
    }
    return Accession;
}());
export { Accession };
var PredefinedLabels = /** @class */ (function () {
    function PredefinedLabels(standard, extended) {
        this.standard = standard;
        this.extended = extended;
        this.combined = standard.concat(extended);
    }
    return PredefinedLabels;
}());
export { PredefinedLabels };
var HcrAmplifier = /** @class */ (function () {
    // it seems they all have id == name for now
    function HcrAmplifier(id) {
        this.id = id;
    }
    return HcrAmplifier;
}());
export { HcrAmplifier };
var PredefinedLabel = /** @class */ (function () {
    function PredefinedLabel(id, name, isStandard) {
        this.id = id;
        this.name = name;
        this.isStandard = isStandard;
    }
    return PredefinedLabel;
}());
export { PredefinedLabel };
/**
 * Amp:
 *  3 uM * 50 ul = 150 pmol
 *  3 uM * 200 ul = 600 pmol
 * Probe:
 *  1 uM * 200 ul = 200 pmol
 */
var Pmol = /** @class */ (function () {
    function Pmol(value) {
        this.valuePmol = value;
        this.ampConcentratedWithUnit = value / 3 + " \u00B5L";
        this.probeConcentratedWithUnit = value + " \u00B5L";
        if (value >= 1000) {
            this.valueWithUnit = value / 1000 + " nmol";
        }
        else {
            this.valueWithUnit = value + " pmol";
        }
    }
    return Pmol;
}());
export { Pmol };
var GoldFishBufferCatalog = /** @class */ (function () {
    function GoldFishBufferCatalog(sampleTypes, defaultSampleType, goldWash, amplifier, hybridization, goldAmpWash, proAmpWash) {
        this.goldWash = goldWash;
        this.amplifier = amplifier;
        this.defaultSampleType = defaultSampleType;
        this.hybridization = hybridization;
        this.sampleTypes = sampleTypes;
        this.goldAmpWash = goldAmpWash;
        this.proAmpWash = proAmpWash;
    }
    return GoldFishBufferCatalog;
}());
export { GoldFishBufferCatalog };
// tslint:disable-next-line:max-classes-per-file
var LegacyFishBufferCatalog = /** @class */ (function () {
    function LegacyFishBufferCatalog(sampleTypes, defaultSampleType, wash, amplifier, hybridization) {
        this.wash = wash;
        this.amplifier = amplifier;
        this.defaultSampleType = defaultSampleType;
        this.hybridization = hybridization;
        this.sampleTypes = sampleTypes;
    }
    return LegacyFishBufferCatalog;
}());
export { LegacyFishBufferCatalog };
// tslint:disable-next-line:max-classes-per-file
var LiquidVolume = /** @class */ (function () {
    function LiquidVolume(valueMl) {
        this.valueMl = valueMl;
        if (valueMl >= 1000) {
            this.valueWithUnit = valueMl / 1000 + " L";
        }
        else {
            this.valueWithUnit = valueMl + " mL";
        }
    }
    return LiquidVolume;
}());
export { LiquidVolume };
// tslint:disable-next-line:max-classes-per-file
var CishUserAmplifierCatalog = /** @class */ (function () {
    function CishUserAmplifierCatalog(amplifierConfig, amplifierScales, defaultAmplifierScales) {
        this.amplifierConfig = amplifierConfig;
        this.amplifierScales = amplifierScales;
        this.defaultAmplifierScale = defaultAmplifierScales;
    }
    return CishUserAmplifierCatalog;
}());
export { CishUserAmplifierCatalog };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAmplifierScale = /** @class */ (function () {
    function RnaCishAmplifierScale(slides, pmolScale, label, detail) {
        this.slides = slides;
        this.pmolScale = pmolScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishAmplifierScale;
}());
export { RnaCishAmplifierScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAntiHapten1Scale = /** @class */ (function () {
    function RnaCishAntiHapten1Scale(slides, unitScale, label, detail) {
        this.slides = slides;
        this.unitScale = unitScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishAntiHapten1Scale;
}());
export { RnaCishAntiHapten1Scale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishTyramideHaptenScale = /** @class */ (function () {
    function RnaCishTyramideHaptenScale(slides, pmolScale, label, detail) {
        this.slides = slides;
        this.pmolScale = pmolScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishTyramideHaptenScale;
}());
export { RnaCishTyramideHaptenScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAntiHapten2ApScale = /** @class */ (function () {
    function RnaCishAntiHapten2ApScale(slides, unitScale, label, detail) {
        this.slides = slides;
        this.unitScale = unitScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishAntiHapten2ApScale;
}());
export { RnaCishAntiHapten2ApScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAntiHapten2HrpScale = /** @class */ (function () {
    function RnaCishAntiHapten2HrpScale(slides, unitScale, label, detail) {
        this.slides = slides;
        this.unitScale = unitScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishAntiHapten2HrpScale;
}());
export { RnaCishAntiHapten2HrpScale };
// tslint:disable-next-line:max-classes-per-file
var CishUserAmplifierConfig = /** @class */ (function () {
    function CishUserAmplifierConfig(id, displayName, protocolType, amplifier, hapten, antiHapten1, tyramideHapten, visible, antiHapten2Ap, antiHapten2Hrp) {
        this.id = id;
        this.displayName = displayName;
        this.protocolType = protocolType;
        this.amplifier = amplifier;
        this.hapten = hapten;
        this.antiHapten1 = antiHapten1;
        this.tyramideHapten = tyramideHapten;
        this.antiHapten2Ap = antiHapten2Ap ? antiHapten2Ap : {
            id: "NONE",
            label: "NONE",
            chromogenCompatibility: "NONE"
        };
        this.antiHapten2Hrp = antiHapten2Hrp ? antiHapten2Hrp : {
            id: "NONE",
            label: "NONE",
            chromogenCompatibility: "NONE"
        };
        this.visible = visible;
    }
    return CishUserAmplifierConfig;
}());
export { CishUserAmplifierConfig };
// tslint:disable-next-line:max-classes-per-file
var Hapten = /** @class */ (function () {
    function Hapten(id) {
        this.id = id;
        this.name = id;
    }
    return Hapten;
}());
export { Hapten };
export var isConsumerCatalog = function (b) {
    return b._type === 'consumer';
};
var isLegacyBufferCatalog = function (b) {
    return b._bufferType === 'legacy';
};
// tslint:disable-next-line:max-classes-per-file
var RnaCishEndogenousEnzymeBufferScale = /** @class */ (function () {
    function RnaCishEndogenousEnzymeBufferScale(slides, volumeScaleUl, label, detail) {
        this.slides = slides;
        this.volumeScaleUl = volumeScaleUl;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishEndogenousEnzymeBufferScale;
}());
export { RnaCishEndogenousEnzymeBufferScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishPreHybridizationBufferScale = /** @class */ (function () {
    function RnaCishPreHybridizationBufferScale(slides, volumeScale, label, detail) {
        this.slides = slides;
        this.volumeScale = volumeScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishPreHybridizationBufferScale;
}());
export { RnaCishPreHybridizationBufferScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishProbeHybridizationBufferScale = /** @class */ (function () {
    function RnaCishProbeHybridizationBufferScale(slides, volumeScale, labelA, labelB, detail) {
        this.slides = slides;
        this.volumeScale = volumeScale;
        this.slidesWithUnit = slides + " slides";
        this.labelA = labelA;
        this.labelB = labelB;
        this.detail = detail;
    }
    return RnaCishProbeHybridizationBufferScale;
}());
export { RnaCishProbeHybridizationBufferScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishHrpQuencherScale = /** @class */ (function () {
    function RnaCishHrpQuencherScale(slides, volumeScale, label, detail) {
        this.slides = slides;
        this.volumeScale = volumeScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishHrpQuencherScale;
}());
export { RnaCishHrpQuencherScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAmplificationBufferScale = /** @class */ (function () {
    function RnaCishAmplificationBufferScale(slides, volumeScaleUl, label, detail) {
        this.slides = slides;
        this.volumeScaleUl = volumeScaleUl;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishAmplificationBufferScale;
}());
export { RnaCishAmplificationBufferScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishBlockingBufferScale = /** @class */ (function () {
    function RnaCishBlockingBufferScale(slides, volumeScaleUl, label, detail) {
        this.slides = slides;
        this.volumeScaleUl = volumeScaleUl;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishBlockingBufferScale;
}());
export { RnaCishBlockingBufferScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAntigenRetrievalScale = /** @class */ (function () {
    function RnaCishAntigenRetrievalScale(slides, volumeScaleUl, label, detail) {
        this.slides = slides;
        this.volumeScaleUl = volumeScaleUl;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishAntigenRetrievalScale;
}());
export { RnaCishAntigenRetrievalScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishDewaxScale = /** @class */ (function () {
    function RnaCishDewaxScale(slides, volumeScaleUl, label, detail) {
        this.slides = slides;
        this.volumeScaleUl = volumeScaleUl;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishDewaxScale;
}());
export { RnaCishDewaxScale };
// tslint:disable-next-line:max-classes-per-file
var RnaCishBluingAgentScale = /** @class */ (function () {
    function RnaCishBluingAgentScale(slides, volumeScale, label, detail) {
        this.slides = slides;
        this.volumeScale = volumeScale;
        this.slidesWithUnit = slides + " slides";
        this.label = label;
        this.detail = detail;
    }
    return RnaCishBluingAgentScale;
}());
export { RnaCishBluingAgentScale };
var ChromogenScale = /** @class */ (function () {
    function ChromogenScale(slides, volumeScaleMl) {
        this.slides = slides;
        this.slidesWithUnit = slides + " slides";
        this.volumeScaleMl = volumeScaleMl;
        this.volumeScaleMlWithUnit = volumeScaleMl + " mL";
    }
    return ChromogenScale;
}());
export { ChromogenScale };
var ChromogenBufferScale = /** @class */ (function () {
    function ChromogenBufferScale(slides, volumeScaleMl) {
        this.slides = slides;
        this.slidesWithUnit = slides + " slides";
        this.volumeScaleMl = volumeScaleMl;
        this.volumeScaleMlWithUnit = volumeScaleMl + " mL";
    }
    return ChromogenBufferScale;
}());
export { ChromogenBufferScale };
var HematoxylinScale = /** @class */ (function () {
    function HematoxylinScale(slides, volumeScaleMl) {
        this.slides = slides;
        this.slidesWithUnit = slides + " slides";
        this.volumeScaleMl = volumeScaleMl;
        this.volumeScaleMlWithUnit = volumeScaleMl + " mL";
    }
    return HematoxylinScale;
}());
export { HematoxylinScale };
export var fetchRnaCatalog = function (mode, catalogType, orderId, product) {
    var path;
    var productPath = '';
    if (product != null) {
        productPath = "?product=" + product;
    }
    switch (mode) {
        case CatalogMode.Consumer:
            switch (catalogType) {
                case RelevantCatalogType.Initial:
                    path = '/order/initial/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Cart:
                    path = '/order/cart/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Orders:
                    path = "/order/orders/catalog/rna/order/" + encodeURIComponent(orderId) + productPath;
                    break;
            }
            break;
        case CatalogMode.Internal:
            switch (catalogType) {
                case RelevantCatalogType.Initial:
                    path = '/admin/initial/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Cart:
                    path = '/admin/cart/catalog/rna' + productPath;
                    break;
                case RelevantCatalogType.Orders:
                    path = "/admin/orders/catalog/rna/order/" + encodeURIComponent(orderId) + productPath;
                    break;
            }
            break;
    }
    return getWithAuthn(path)
        .then(function (resp) {
        // TODO Check for 200
        return resp.json();
    })
        .then(function (jsonCatalog) {
        if (mode === CatalogMode.Consumer) {
            return deserializeUserCatalog(jsonCatalog);
        }
        else {
            return deserializeAdminCatalog(jsonCatalog);
        }
    });
};
// tslint:disable-next-line:max-classes-per-file
var MicroliterVolume = /** @class */ (function () {
    function MicroliterVolume(valueUl) {
        this.valueUl = valueUl;
        if (valueUl >= 1000) {
            this.valueWithUnit = valueUl / 1000 + " mL";
        }
        else {
            this.valueWithUnit = valueUl + " \u00B5L";
        }
    }
    return MicroliterVolume;
}());
export { MicroliterVolume };
// tslint:disable-next-line:max-classes-per-file
var Unit = /** @class */ (function () {
    function Unit(value) {
        this.valueUnit = value;
        this.valueWithUnit = value + " U";
    }
    return Unit;
}());
export { Unit };
export var RelevantCatalogType;
(function (RelevantCatalogType) {
    RelevantCatalogType[RelevantCatalogType["Initial"] = 0] = "Initial";
    RelevantCatalogType[RelevantCatalogType["Cart"] = 1] = "Cart";
    RelevantCatalogType[RelevantCatalogType["Orders"] = 2] = "Orders";
})(RelevantCatalogType || (RelevantCatalogType = {}));
//# sourceMappingURL=RnaCatalog.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/RnaCatalog.js
// module id = 11
// module chunks = 0